<h2 class="LeftPanelTitle">
  {{ "app.view.editor-side-view.editor-tools-view-component.more-functions" | translate }}
</h2>
<sbb-accordion [multi]="true">
  <sbb-expansion-panel [expanded]="true">
    <sbb-expansion-panel-header>{{
      "app.view.editor-side-view.editor-tools-view-component.export" | translate
    }}</sbb-expansion-panel-header>
    <button
      class="TrainrunDialog EditorToolButton"
      (click)="onExportContainerAsSVG()"
      [title]="
        'app.view.editor-side-view.editor-tools-view-component.export-container-as-svg'
          | translate: {container: getContainerName()}
      "
    >
      <sbb-icon svgIcon="picture-small"></sbb-icon>
    </button>
    {{ "app.view.editor-side-view.editor-tools-view-component.export-as-svg" | translate }}
    <br />
    <button
      class="TrainrunDialog EditorToolButton"
      (click)="onExportContainerAsPNG()"
      [title]="
        'app.view.editor-side-view.editor-tools-view-component.export-container-as-png'
          | translate: {container: getContainerName()}
      "
    >
      <sbb-icon svgIcon="camera-small"></sbb-icon>
    </button>
    {{ "app.view.editor-side-view.editor-tools-view-component.export-as-png" | translate }}
    <br />
    <button
      class="TrainrunDialog EditorToolButton"
      (click)="onPrintContainer()"
      [title]="
        'app.view.editor-side-view.editor-tools-view-component.print-container'
          | translate: {container: getContainerName()}
      "
    >
      <sbb-icon svgIcon="printer-small"></sbb-icon>
    </button>
    {{ "app.view.editor-side-view.editor-tools-view-component.print" | translate }}
  </sbb-expansion-panel>

  <sbb-expansion-panel [expanded]="false">
    <sbb-expansion-panel-header>{{
      "app.view.editor-side-view.editor-tools-view-component.netzgrafik" | translate
    }}</sbb-expansion-panel-header>
    <button
      class="TrainrunDialog EditorToolButton"
      (click)="onSave()"
      [title]="
        'app.view.editor-side-view.editor-tools-view-component.export-netzgrafik' | translate
      "
    >
      <sbb-icon svgIcon="download-small" aria-hidden="false"></sbb-icon>
    </button>
    {{
      "app.view.editor-side-view.editor-tools-view-component.export-netzgrafik-as-json" | translate
    }}
    <ng-container *ngIf="getVariantIsWritable()">
      <br />
      <button
        (click)="onLoadButton()"
        [title]="
          'app.view.editor-side-view.editor-tools-view-component.import-netzgrafik' | translate
        "
        class="TrainrunDialog EditorToolButton"
      >
        <sbb-icon svgIcon="upload-small"></sbb-icon>
      </button>
      <input hidden #netzgrafikJsonFileInput type="file" accept=".json" (change)="onLoad($event)" />
      {{
        "app.view.editor-side-view.editor-tools-view-component.import-netzgrafik-as-json"
          | translate
      }}
    </ng-container>

    <br />
    <button
      (click)="onExportZuglauf()"
      [title]="'app.view.editor-side-view.editor-tools-view-component.export-trainruns' | translate"
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon svgIcon="download-large-data-small"></sbb-icon>
    </button>
    {{
      "app.view.editor-side-view.editor-tools-view-component.export-trainruns-as-csv" | translate
    }}
    <sbb-tooltip>{{
      "app.view.editor-side-view.editor-tools-view-component.export-trainruns-as-csv-excel"
        | translate
    }}</sbb-tooltip>
    <br />
    <button
      (click)="onExportOriginDestination()"
      [title]="
        'app.view.editor-side-view.editor-tools-view-component.export-origin-destination'
          | translate
      "
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon
        _ngcontent-ng-c1568279807=""
        role="img"
        svgicon="chart-line-medium"
        height="25px"
        width="25px"
        aria-hidden="false"
        class="sbb-icon notranslate"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="16 -20 72 94"
          fit=""
          preserveAspectRatio="xMidYMid meet"
          focusable="false"
        >
          <g transform="rotate(30),scale(2.0),translate(20,-8)">
            <path
              d="M21.25 15.75c0 4.377-1.308 7.222-3.342 8.982-2.047 1.772-4.91 2.518-8.158 2.518v1c3.38 0 6.516-.774 8.813-2.762 2.309-2 3.687-5.155 3.687-9.738V9.482l3.857 3.849.707-.708L22.09 7.91l-.353-.353-.353.354-4.712 4.713.707.707 3.871-3.872z"
            />
          </g>
          <g transform="scale(2.5),translate(3,10)">
            <path
              width="26"
              height="20"
              d="M8 1C5.264 1 3 3.107 3 5.762v.021c.035.833.297 1.531.704 2.174l.007.01 3.886 5.811.416.621.416-.621 3.886-5.81.007-.01.006-.011c.393-.654.664-1.367.672-2.18v-.005C13 3.107 10.735 1 8 1M4.546 7.416C4.22 6.901 4.028 6.374 4 5.752 4.006 3.704 5.768 2 8 2c2.234 0 3.999 1.708 4 3.76-.006.58-.195 1.115-.523 1.661l-3.464 5.18zM6.5 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M8 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
            />
          </g>
          <g transform="rotate(-90),scale(2.0)translate(-22,23)">
            <path
              fill="#000"
              fill-rule="evenodd"
              d="M14.5 7a5.5 5.5 0 1 0 .002 11.002A5.5 5.5 0 0 0 14.5 7M3 13h5.019a6.5 6.5 0 1 0 0-1H3zm11.5 3a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
              clip-rule="evenodd"
            />
          </g>
        </svg>
      </sbb-icon>
    </button>
    {{
      "app.view.editor-side-view.editor-tools-view-component.export-origin-destination-as-csv"
        | translate
    }}
  </sbb-expansion-panel>
  <sbb-expansion-panel [expanded]="false">
    <sbb-expansion-panel-header>{{
      "app.view.editor-side-view.editor-tools-view-component.base-data" | translate
    }}</sbb-expansion-panel-header>
    <ng-container *ngIf="getVariantIsWritable()">
      <button
        (click)="onLoadBaseDataButton()"
        [title]="
          'app.view.editor-side-view.editor-tools-view-component.import-base-data' | translate
        "
        class="TrainrunDialog EditorToolButton"
      >
        <sbb-icon svgIcon="document-plus-small"></sbb-icon>
      </button>
      {{ "app.view.editor-side-view.editor-tools-view-component.import-base-data" | translate }}
      <a
        href="https://github.com/SchweizerischeBundesbahnen/netzgrafik-editor-frontend/blob/main/documentation/CREATE_NODES.md#import-nodes-from-a-semicolon-separate-value-file-csv"
        class="sbb-link link-reset"
        target="_blank"
        >{{ "app.view.editor-side-view.editor-tools-view-component.help-csv-data" | translate }}</a
      >
      <input
        hidden
        #baseDataFileInput
        type="file"
        accept=".csv"
        (change)="onLoadBaseData($event)"
      />
      <br />
    </ng-container>
    <button
      (click)="onExportBaseData()"
      [title]="'app.view.editor-side-view.editor-tools-view-component.export-base-data' | translate"
      class="TrainrunDialog EditorToolButton"
    >
      <sbb-icon svgIcon="download-large-data-small"></sbb-icon>
    </button>
    {{ "app.view.editor-side-view.editor-tools-view-component.export-base-data" | translate }}
  </sbb-expansion-panel>
</sbb-accordion>
